export default function WorksDashboardView() {
    return (
        <section>
            Dashboard admin WORKS
        </section>
    )
}